import { SegmentListItem } from "common/ListItems";
import * as favoritesActions from "lib/api/favorites";
import { connect } from "react-redux";

const mapDispatchToProps = (dispatch) => ({
  unpin: (id) => dispatch(favoritesActions.unpin("segment", id)),
});

const mapStateToProps = (state, ownProps) => {
  const favorites = state.favorites;

  return {
    pinned: !!favorites.getIn(["favoritesByType", "segment", ownProps.segment.get("id")]),
  };
};

export const SegmentListItemContainer = connect(mapStateToProps, mapDispatchToProps)(SegmentListItem);
